import axios from 'axios'
import { API_URL  } from '@/api-config';
import router from '../router/index'

const axiosApi = axios.create({
  baseURL: API_URL
});

axiosApi.interceptors.request.use(
  config => {
    const token = localStorage.getItem('@profile-analyst-token');
    if (token) {
      config.headers['x-token'] = token
    }

    return config
  }
)

axiosApi.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      router.push('/login');
    }

    return Promise.reject(error);
  }
)

export default axiosApi;